module.exports = __webpack_public_path__ + "img/bg01_1_zhTc.b0532b40.png";